import "./contactUs.css";
import darkFilter from "./assets/darkFilter.svg"
import imagePart from "./assets/imagePart.svg"
import doorImage from "./assets/doorImage.svg"
import location from "./assets/location.svg"
import phone from "./assets/phone.svg"
import mail from "./assets/mail.svg"
import { useEffect, useState } from "react";
import { contactUsPoints } from "../../services/apis";
import { makeAuthenticatedPOSTRequest } from "../../services/serverHelper";
import { makeAuthenticatedGETRequest } from "../../services/serverHelper";
import { artistProfilePoints } from "../../services/apis";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Artist_navbar from "../Artist_navbar"
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice";
import Sidebar from "../../../components/Sidebar"
// Sidebar imports
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaUser,
  FaBriefcase,
  FaBook,
  FaNewspaper,
  FaSignOutAlt,
  FaIdBadge,
  FaEnvelope,
} from "react-icons/fa";
import "../Dashboard/dashboard.css";

import axios from 'axios';
import contactImage from '../../../assets/contact.jpeg';
import contactImageBanner from '../../../assets/ContactUS.png';

const formDetail = [
    {
        placeholder:"Enter your name" , 
        type:"text" , 
        name:"name",
        hidden:true
    },
    {
        placeholder:"Enter your email" , 
        type:"email" , 
        name:"email",
        hidden:true
    },
];

const boxDetail = [
    {
        image:phone , 
        text:"Phone",
        detail:"+914785236987"
    },
    {
        image:mail , 
        text:"Email",
        detail:"supportekalakaar@gmail.com"
    },
    {
        image:location , 
        text:"Address",
        detail:"123, Random Street, Random City, Mumbai - 123456"
    },
];

function ContactUs() {
    const {accessToken} = useSelector((state)=>state.auth)
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const API_A = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        contactNumber: '',
        email: '',
        city: '',
        purpose: '',
        message: '',
      });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        }));
    };
    
     const handleSubmit = async (e) => {
        e.preventDefault();
         setLoading(true); // disable the button
    
        try {
          const response = await axios.post(`${API_A}/queries/post-query`, formData);
         
          // console.log('New contact saved:', newContact);  // Debugging log
          alert('Form submitted successfully!');
          setFormData({
            name: '',
            contactNumber: '',
            email: '',
            city: '',
            purpose: '',
            message: '',
          });  // Reset form after submission
        } catch (error) {
          console.error('Error submitting the form', error);
          alert('Error submitting the form. Please try again.');
        }
        finally {
        setLoading(false); // re-enable the button
      }
      };    

    const [portfolioData , setPortfolioData] = useState(null);

    const fetchUserData = async()=>{
        try{
            const response = await makeAuthenticatedGETRequest(`${artistProfilePoints.FETCH_PROFILE_DATA_API}/${localStorage.getItem("artId")}` , accessToken);

            console.log('res' ,response);

            if(response.status === 'success'){
                const {address, socialLinks , personalInfo ,artInfo, performanceInfo } = response.data;

                setFormData({
                    email : personalInfo?.email  , name:personalInfo?.firstName 
                })
            }else{
                toast.error('something went wrong , please refresh the page' , {
                    position:"top-center"
                });
            }
        } catch(error){
            console.log(error);
        }
    }
    
    useEffect(()=>{
        fetchUserData();
    },[])
    
    const changeHandler = (event)=>{
        const {name , value} = event.target;
        setFormData((prev)=>({
            ...prev , 
            [name]:value
        }))
    }
    

    return (
        <>
            <Artist_navbar />
            <div className="dashboard-layout">
                <Sidebar />
                {/* -------- Main Content -------- */}
                <section id="contact" className="w-screen bg-white overflow-hidden z-0">
                    {/* Heading */}
                    <div className=' mx-4  md:mx-6 lg:mx-0 xl:mx-16'>
                    <div style={{backgroundImage: `url(${contactImageBanner})`}} className="text-center rounded-[20px] bg-cover bg-center w-full h-[40vh] mb-8 md:mb-12 lg:mb-16 mt-6 md:mt-10 lg:mt-12 xl:mt-14">
                        <div className="w-full h-full rounded-[20px] bg-black bg-opacity-50 flex items-center justify-center">
                            <h2 className="text-[#FFFFFF] w-full h-full flex justify-center items-center font-bold text-[20px] sm:text-[1.5rem] md:text-[1.75rem] lg:text-[2rem] xl:text-[2.25rem] leading-snug" style={{textDecoration:"none"}}>
                                GET IN TOUCH
                            </h2>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="max-w-full mx-auto px-2 sm:px-6 lg:px-4 pb-12 md:pb-16 lg:pb-20">
                        <div className="sm:px-2  md:px-8 lg:px-12  xl:px-6">
                <div className="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-10 xl:gap-12 items-center lg:items-start lg:h-[28rem] xl:h-[34rem]">
                {/* Image */}
                <div className="w-full lg:w-1/2 h-full z-10">
                    <img
                    src={contactImage}
                    alt="Contact"
                    className="w-full h-full object-cover rounded-md"
                    />
                </div>

                {/* Form + Button */}
                <div className="w-full lg:w-1/2 h-full flex flex-col justify-between">
                    <form
                    
                    onSubmit={handleSubmit}
                    >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-3 xl:gap-4">
                    {/* Input Fields */}
                    {[
                        { label: 'Name:', name: 'name', type: 'text', placeholder: 'Enter Name' },
                        { label: 'Contact Number:', name: 'contactNumber', type: 'tel', placeholder: 'Enter Contact No.' },
                        { label: 'Email ID:', name: 'email', type: 'email', placeholder: 'Enter Email ID' },
                        { label: 'City:', name: 'city', type: 'text', placeholder: 'Enter City' },
                    ].map((field) => (
                        <div key={field.name}>
                        <label className="text-[#AD2F3B] font-semibold block mb-1 
                            text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]">
                            {field.label}
                        </label>
                        <input
                            type={field.type}
                            name={field.name}
                            placeholder={field.placeholder}
                            value={formData[field.name]}
                            onChange={handleChange}
                            required={field.name !== 'city'}
                            className="w-full border border-gray-300 rounded-lg px-2 py-1.5 outline-none 
                            text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]"
                        />
                        </div>
                    ))}

                    {/* Purpose Dropdown */}
                    <div className="md:col-span-2">
                        <label className="text-[#AD2F3B] font-semibold block mb-1 
                        text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]">
                        Purpose:
                        </label>
                        <select
                        name="purpose"
                        value={formData.purpose}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 rounded-lg px-2 py-2 outline-none text-gray-700 
                            text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]"
                        >
                        <option value="">Select Purpose</option>
                        <option>Business Enquiry</option>
                        <option>General Enquiry</option>
                        <option>Media Enquiry</option>
                        <option>Work with us</option>
                        <option>Feedback</option>
                        <option>Volunteer</option>
                        <option>Internship</option>
                        <option>Other</option>
                        </select>
                    </div>

                    {/* Message */}
                    <div className="md:col-span-2">
                        <label className="text-[#AD2F3B] font-semibold block mb-1 
                        text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]">
                        Message:
                        </label>
                        <textarea
                        name="message"
                        placeholder="Enter your message here..."
                        value={formData.message}
                        onChange={handleChange}
                        required
                        className="w-full border border-gray-300 rounded-lg px-2 py-1.5 outline-none resize-none 
                            h-[6rem] md:h-[7rem] lg:h-[7rem] xl:h-[8rem]
                            text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.925rem] xl:text-[1.05rem]"
                        ></textarea>
                    </div>
                    </div>
                    <div className="w-full flex justify-center mt-4 lg:mt-2">
                <button
                    type="submit"
                    disabled={loading}
                    className="px-5 md:px-6 py-2 rounded-full 
                    bg-[#AD2F3B] text-white 
                    hover:shadow-[0_4px_10px_rgba(0,0,0,0.3)] 
                    transition-all duration-300 
                    text-[0.75rem] sm:text-[0.85rem] md:text-[0.9rem] lg:text-[0.95rem] xl:text-[1.05rem]"
                >
                    {loading ? 'Submitting...' : 'Submit'}
                </button>
                </div>
                    </form>

                    {/* Submit Button */}


                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                    </section>
            </div>
            <ToastContainer />
        </>
    );
}

export default ContactUs;